module.exports = __webpack_public_path__ + "img/villa-g7565f07ba_1920.546cb155.jpg";